function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.851 15.767a.567.567 0 01.565-.566 6.784 6.784 0 006.785-6.784 6.784 6.784 0 00-6.785-6.785 6.783 6.783 0 00-6.785 6.785.566.566 0 01-.565.564.566.566 0 01-.566-.564A7.917 7.917 0 018.417.501a7.917 7.917 0 017.916 7.916 7.917 7.917 0 01-7.916 7.915.565.565 0 01-.566-.565zM4.59 12.735a.565.565 0 01.072-.8l3.189-2.657V4.455a.566.566 0 01.566-.566.566.566 0 01.564.566v5.088a.566.566 0 01-.2.437l-3.393 2.827a.563.563 0 01-.359.129.568.568 0 01-.438-.201z",
  strokeMiterlimit: 10
});

function SvgIconClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.832 16.832",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgIconClock;